import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ProduitChampComplementaire, ProduitDTO, ProduitDTOSchema, QueryParams0101DTO } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
  providedIn: "root"
})
export class ProduitService {
  private readonly http = inject(HttpClient);
  private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, ProduitDTOSchema);

  /**
   * récupère les détails du produit de l'utilisateur actuellement sélectionné
   * @returns détails du produit
   */
  getCurrentProduitDetails(codeProduit: string): Observable<ProduitDTO> {
    const msParams: QueryParams0101DTO = {
      codeProduit,
      champsComplementaires: [ProduitChampComplementaire.COMPARTIMENTS]
    };
    return this.http.get<ProduitDTO>(environment.urlsMs.MS0101, {
      params: msParams,
      context: this.context
    });
  }

  /**
   * récupère les détails du produit en fonction de son code
   * @param codeProduit code du produit
   * @param champsComplementaires informations complémentaires voulues sur le produit
   * @returns détails du produit
   */
  getProduit(codeProduit: string, champsComplementaires: ProduitChampComplementaire[] = []): Observable<ProduitDTO> {
    const msParams: QueryParams0101DTO = {
      codeProduit,
      champsComplementaires
    };
    return this.http.get<ProduitDTO>(environment.urlsMs.MS0101, {
      context: this.context,
      params: msParams
    });
  }
}
